<div class="row" *ngIf="enable">
  <div class="col-sm-12">
    <table>
      <tr class="card-row" *ngFor="let treat of dvmp_treatmentlabel; let i=index;"
        [ngClass]="{'with-checkbox': i==0  && indexparent==0 && crcycle == 1}">
        <td>
          <div class="tretalabel">{{ treat.label | titlecase  }} </div>
        </td>
        <td>
          <div class="treat-options">
            <select id='Slectbar{{crcycle}}{{i}}' class="form-control cycles" [(ngModel)]="defaultvalue[i]"
              (change)="defCahange(i, $event,dvmp_treatmentlabel)" [disabled]="!_dvmp.SMPCDefintionDropdowns">
              <option *ngFor="let treatval of treat.value;" value="{{treatval.trim()}}"> {{ treatval }}</option>
              this.selectedTreatment= this.patientdata.data.Tratamientos
              <option value="" *ngIf = "crcycle>= emptyvalue && (selectedTreatment ==='DVmp'|| selectedTreatment
                ==='DVd') "></option>
            </select>
            <div class="checkvalue" *ngIf="i==0  && indexparent==0 && crcycle == 1 ">
              <span i18n="@@doseDevide">Dose devide en</span>
              <input type="checkbox" id="checboxCheck" class="firstcyclecheck" name="checkbox" value=""
                [(ngModel)]="checkValue" (change)="splitDoseSelected(checkValue,$event)">
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="ErrorCycle" id="ErrorCycle{{crcycle}}"> </div>
</div>